import React from "react"
import "../styles/Agent.css"

export default function Agent(){

	return(<>

				<div id='agent'>

					<img class="agent-img" src="images/real-estate-agent.jpeg"/>




				</div>



		</>)







}